// TODO: maybe add this file to .gitignore? or replace values here with environment variables (via parcel process.env)
// not because this is confidential information, but to avoid people cloning the project to accidentally forget to change these.
export const PRODUCTION_SERVER_BASE_URL = "https://api.musiverkko.com";
// export const DEVELOPMENT_SERVER_BASE_URL = "http://127.0.0.1:8000";
export const DEVELOPMENT_SERVER_BASE_URL = "http://localhost:8000";
export const PRODUCTION_ANALYTICS_KEY = "musiverkko.com";
